import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import TableSection from './Table/Table';
import * as actions from '../../store/actions/report_actions';

class ReplymakerContent extends Component {
	
	componentWillUnmount() {
		this.props.clearReports();
	}

	render() {
		return (
			<div className="analytics-dashboard-content">
				<div className="row">
					<div className="col-sm-12">
						<TableSection manage={this.props.manage} />
					</div>
				</div>
			</div>
		);
	}
};

const mapActionToProps = dispatch => {
	return {
		clearReports: () => dispatch(actions.clearReports())
	};
};

export default withRouter(connect(null, mapActionToProps)(ReplymakerContent));